const doc = [({"sumResult":"Sie trinken rund <strong>{amount} Liter</strong> reinen Alkohol im Jahr."})];
module.exports = doc.length <= 1 ? doc[0] : doc;